module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/218-turkey-303cc9e0018bada0c7026bd9bf76df6f.svg";